import { Getters } from 'vuex-smart-module';
import { UserRoles } from '@/enums';
import UserState from './state';

export default class UserGetters extends Getters<UserState> {
  get me_shared() {
    return this.state.me;
  }

  get is_partner_manager() {
    const manager = UserRoles.Internal.PARTNER_MANAGER;

    return this.state.me?.roles?.length && this.state.me?.roles.some((el) => el.slug === manager);
  }

  get is_vice_partner_manager() {
    const manager = UserRoles.Internal.VICE_PARTNER_MANAGER;

    return this.state.me?.roles?.length && this.state.me?.roles.some((el) => el.slug === manager);
  }

  get is_admin() {
    const admin = UserRoles.External.ADMIN;

    return this.state.me?.roles?.length && this.state.me?.roles.some((el) => el.slug === admin);
  }
}
